var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart-contributions',{attrs:{"height":_vm.height,"itemIds":[],"userIds":[_vm.me.id],"granularity":_vm.granularity,"duration":_vm.duration,"startComputing":_vm.startComputing}})}
var staticRenderFns = []

export { render, staticRenderFns }